import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Main from "./SubPages/Main.js";
import List1 from "./SubPages/List1.js";
import List2 from "./SubPages/List2.js";
import List3 from "./SubPages/List3.js";

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Main />} />
        <Route path="/List1" element={<List1 />} />
        <Route path="/List2" element={<List2 />} />
        <Route path="/List3" element={<List3 />} />
      </Routes>
    </Router>
  );
}

export default App;
